import { Row, Col } from "antd";
import styled from "styled-components";
import { SharedDoseIconButton, PlusIcon, SpotIcon, RefreshIcon, VaadinPillPrimaryIcon, VaadinPillWhiteIcon, VectorIcon } from "@components";
import SyringePrimaryIcon from "@components/icons/svg/syringe_primary_icon.svg";
import SyringeWhiteIcon from "@components/icons/svg/syringe_white_icon.svg";
// import { SharedDoseIconButton } from "../shared";
interface IProps {
  new_client_under_25: number,
  new_client_over_25: number,
  old_client_under_25: number,
  old_client_over_25: number,
  consultation: string;
  callbackBtnClick: (client_info: string, doseCount: number) => void;
}
export const ClientDoseForm = ({
  new_client_under_25,
  new_client_over_25,
  old_client_under_25,
  old_client_over_25,
  consultation,
  callbackBtnClick
}: IProps) => {
  return (
    <>
      <Row>
        <Col span={4}></Col>
        <Col span={20}>
            <StyledBgPrimaryColumnText>{consultation === "DMPA_IM" ? "DMPA-IM Consultation" : "OC-Pills Consultation"} </StyledBgPrimaryColumnText>
        </Col>
      </Row>
      <Row>
        <Col lg={4} xs={0} ></Col>
        <Col lg={10} xs={0} >
          <StyledColumnText>Under 25 years old</StyledColumnText>
        </Col>
        <Col lg={10} xs={0} >
          <StyledColumnText>Over 25 years old</StyledColumnText>
        </Col>
      </Row>
      <Row>
        <Col span={4}>
          <StyledClientRoleColumnInner>
            <div>
              <h5>New Client</h5>
              <div><VectorIcon color="#FFFFFF" /></div>
              <div>
                {
                  consultation === "OC_PILL" ? 
                  <>
                    <span>Every</span><br />
                    <span>1 Month</span>
                  </> 
                  : 
                  <>
                    <span>Every</span><br />
                    <span>3 Months</span>
                  </> 
                }  
              </div>
            </div>
          </StyledClientRoleColumnInner>
        </Col>
        <Col span={20}>
          <Row>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Row>
                <Col span={24} lg={0}><StyledColumnText>Under 25 years old</StyledColumnText></Col>
                <Col span={24}>
                  <DoseButtonCard consultation={consultation} clientInfo="new_client_under_25" doseCount={new_client_under_25} callbackBtnClick={(client_info, dose_count) => callbackBtnClick(client_info, dose_count)} />
                </Col>
              </Row>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Row>
                <Col span={24} lg={0}><StyledColumnText>Over 25 years old</StyledColumnText></Col>
                <Col span={24}>
                  <DoseButtonCard consultation={consultation} clientInfo="new_client_over_25" doseCount={new_client_over_25} callbackBtnClick={(client_info, dose_count) => callbackBtnClick(client_info, dose_count)} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={4}>
          <StyledClientRoleColumnInner>
            <div>
              <h5>Old Client</h5>
              <div><VectorIcon color="#FFFFFF" /></div>
              <div>
                {
                  consultation === "OC_PILL" ? 
                  <>
                    <span>Every</span><br />
                    <span>1 Month</span>
                  </> 
                  : 
                  <>
                    <span>Every</span><br />
                    <span>3 Months</span>
                  </> 
                }
              </div>
            </div>
          </StyledClientRoleColumnInner>
        </Col>
        <Col span={20}>
          <Row>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Row>
                <Col span={24} lg={0}><StyledColumnText>Under 25 years old</StyledColumnText></Col>
                <Col span={24}>
                  <DoseButtonCard consultation={consultation} clientInfo="old_client_under_25" doseCount={old_client_under_25} callbackBtnClick={(client_info, dose_count) => callbackBtnClick(client_info, dose_count)} />
                </Col>
              </Row>
            </Col>
            <Col lg={12} md={24} sm={24} xs={24}>
              <Row>
                <Col span={24} lg={0}><StyledColumnText>Over 25 years old</StyledColumnText></Col>
                <Col span={24}>
                  <DoseButtonCard consultation={consultation} clientInfo="old_client_over_25" doseCount={old_client_over_25} callbackBtnClick={(client_info, dose_count) => callbackBtnClick(client_info, dose_count)} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

interface IDoseButtonCardProps {
  consultation: string,
  clientInfo: string,
  doseCount: number,
  callbackBtnClick: (client_info: string, doseCount: number) => void;
};

const renderButtonIcon = (consultation: string, status: string) => {
  return (
    <>
    {
      consultation === "OC_PILL" ?
      status === "selected" ? <VaadinPillWhiteIcon />: <VaadinPillPrimaryIcon />
      :
      status === "selected" ? <img src={SyringeWhiteIcon} alt="icon" width={22} height={22} /> : <img src={SyringePrimaryIcon} alt="icon" width={22} height={22} />
    }
    </>
  );
};

const DoseButtonCard = ({consultation, clientInfo, doseCount, callbackBtnClick}: IDoseButtonCardProps) => {
  return (
  <StyledColumnInner>
    <StyleButtonWrap>
      {
        new Array(50).fill(null).map((_, i) =>
        <>
        {
          doseCount <= i ? 
          <SharedDoseIconButton type="primary" ghost icon={renderButtonIcon(consultation, "no_selected")} onClick={() => callbackBtnClick(clientInfo, doseCount + 1)} />
          : 
          <SharedDoseIconButton type="primary" icon={renderButtonIcon(consultation, "selected")} onClick={() => callbackBtnClick(clientInfo, doseCount - 1)} />
        }
        </>
        )
      }
    </StyleButtonWrap> 
  </StyledColumnInner>
  );
};

const StyledColumnInner = styled.div`
  border: 1px solid #ccc;
  text-align: center;
  padding: 10px;
  height: 100%
`;

const StyledClientRoleColumnInner = styled(StyledColumnInner)`
  background-color: #F06D24;
  border-radius: 10px 0 0 10px;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  > div h5{
    font-size: 18px;
  }
`;

const StyledColumnText = styled.div`
  background-color: #D9D9D9;
  border: 1px solid #ccc;
  color: #333333;
  padding: 5px;
  text-align: center;
  font-weight: bold;
`;

const StyledBgPrimaryColumnText = styled(StyledColumnText)`
  background-color: #F06D24;
  border-radius: 10px 10px 0px 0px;
  padding: 7px;
  color: #FFFFFF;
  font-size: 15px;
`;

const StyleButtonWrap = styled.div`
  text-align: left;
  display: inline-block;
  margin: 0 auto; 
`;
